// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_3r-1";
export var movingGradient = "_3r-4";
export var movingGradientBlock = "_3r-2";
export var skeleton = "_3r-0";
export var skeletonText = "_3r-3";